import * as React from 'react'

import FormDropdown, { FormStyles } from 'embed/components/FormDropdown'
import { DropdownItem } from 'embed/constants'
import { Filter, LoanPurposeOptions } from 'even-ts-static'
export interface Props {
  containerClass?: string
  items: DropdownItem<unknown>[]
  hidden?: boolean
  onChange?: (fieldName: string, value: string, isValid: boolean) => void
  styles: FormStyles
  startingValue?: LoanPurposeOptions
}

const Render: React.SFC<Props> = ({ containerClass, hidden, items, onChange, startingValue, styles }) =>
  (!hidden && (
    <FormDropdown
      containerClass={containerClass}
      fieldName={Filter.LoanPurpose}
      items={items}
      label="Loan Purpose"
      onChange={onChange}
      startingValue={startingValue}
      styles={styles}
    />
  )) || <></>

Render.defaultProps = {
  containerClass: '',
  onChange: () => null,
  styles: {
    dropDown: '',
    dropDownLabel: '',
    fieldError: '',
  },
}

export default Render
